import { Environment } from '@react-three/drei';
import Spiral from './Spiral';
import Column from './Column';
import LowerEnd from './LowerEnd';
import UpperEnd from './UpperEnd';
import ReturnChannel from './ReturnChannel';
import Guide from './Guide';
import MultiLevel from './MultiLevel';
import Drive from './Drive';

function SpiralVeyorCore({
  inputs,
  result,
  convRatio,
  color,
  drawingBaseDimensions,
}) {
  const hasDrive =
    inputs &&
    inputs.drive != null &&
    typeof inputs.drive === 'object' &&
    Object.keys(inputs.drive).length > 0;

  return (
    <>
      <ambientLight intensity={0.8} />
      <Spiral
        convRatio={convRatio}
        color={color}
        drawingBaseDimensions={drawingBaseDimensions}
      />
      {drawingBaseDimensions.outside_guide_type === 'Stainless steel' &&
        drawingBaseDimensions.outside_guide_height > 0 && (
          <Guide
            convRatio={convRatio}
            guideRadius={
              drawingBaseDimensions.column_centre_to_inside_outer_guide +
              drawingBaseDimensions.outside_guide_thickness / 2
            }
            guideHeight={drawingBaseDimensions.outside_guide_height}
            guideThickness={drawingBaseDimensions.outside_guide_thickness}
            color="silver"
            drawingBaseDimensions={drawingBaseDimensions}
          />
        )}
      {drawingBaseDimensions.inside_guide_type === 'Stainless steel' &&
        drawingBaseDimensions.inside_guide_height > 0 && (
          <Guide
            convRatio={convRatio}
            guideRadius={
              drawingBaseDimensions.column_centre_to_inside_windings -
              drawingBaseDimensions.outside_guide_thickness / 2
            }
            guideHeight={drawingBaseDimensions.inside_guide_height}
            guideThickness={drawingBaseDimensions.inside_guide_thickness}
            color="silver"
            drawingBaseDimensions={drawingBaseDimensions}
          />
        )}
      <Column
        inputs={inputs}
        convRatio={convRatio}
        color={color}
        drawingBaseDimensions={drawingBaseDimensions}
      />
      <LowerEnd
        convRatio={convRatio}
        color={color}
        drawingBaseDimensions={drawingBaseDimensions}
      />
      <UpperEnd
        convRatio={convRatio}
        color={color}
        drawingBaseDimensions={drawingBaseDimensions}
      />
      {inputs.return_channel_le !== 'No return channel' && (
        <ReturnChannel
          convRatio={convRatio}
          color={color}
          drawingBaseDimensions={drawingBaseDimensions}
        />
      )}
      {hasDrive && (
        <Drive
          inputs={inputs}
          convRatio={convRatio}
          drawingBaseDimensions={drawingBaseDimensions}
        />
      )}
      <MultiLevel
        result={result}
        convRatio={convRatio}
        drawingBaseDimensions={drawingBaseDimensions}
      />
      <Environment files="/hdr/studio_small_03_1k.hdr" background={false} />
    </>
  );
}

export default SpiralVeyorCore;
